import { createSelector } from 'reselect';
import { AUTHENTICATED, ERROR, IDLE, LOADING, NOT_AUTHENTICATED } from './constants/authStatuses';

// auth
const getAuth = state => state.auth;

export const getIsIdle = createSelector(getAuth, state => state === IDLE);
export const getIsAuthenticated = createSelector(getAuth, state => state === AUTHENTICATED);
export const getIsNotAuthenticated = createSelector(getAuth, state => state === NOT_AUTHENTICATED);
export const getIsAuthenticating = createSelector(getAuth, state =>
  [IDLE, LOADING].includes(state)
);
export const getAuthError = createSelector(getAuth, state => state === ERROR);
